// ATCD Adulte
import ATCDAdultePersonnel from '@/views/consultations/en-cours/antecedent-adulte-personnel'
import ATCDAdulteFamiliaux from '@/views/consultations/en-cours/antecedent-adulte-familiaux'

export default {
    name: 'recap-dmp',
    components: {
        ATCDAdultePersonnel, ATCDAdulteFamiliaux
    },
    props: ["activeRole"],
    data() {
        return {
            global_dmp_loading: true,
            type_dmp_loading: true,
            type_dmp_is_empty: false,
            can_see_atcd: false,
            is_old_atcd: true,
        }
    },
    computed: {
        consultationEnCours() {
            return this.$store.getters["consultationPatientEnCours"]
        },

        all_patient_dmp() {
            return this.$store.getters['all_patient_dmp']
        },
    },
    mounted() {
        this.refreshConsultationTypeDmp()

        if (this.consultationEnCours.tarif_consultation) {
            if (
                this.consultationEnCours.tarif_consultation.type_consultation.nom != 'Consultation Néonatologique' && 
                this.consultationEnCours.tarif_consultation.type_consultation.nom != 'Consultation d\'allergologie' && 
                this.consultationEnCours.tarif_consultation.type_consultation.nom != 'Pédiatrie'
            ) {
                this.can_see_atcd = true
            }
        }   
        
    },
    methods: {
        refreshConsultationTypeDmp() {
            this.global_dmp_loading = true

            this.$store.dispatch('getAllPatientDmp', this.$route.params.id).then(() => {
                this.global_dmp_loading = false
            })
        },

        editer(type_dmp) {
            let dmp = ''
            if (type_dmp == 'antecedent_generaux') {
                dmp = 'Antécédents généraux'
            } else if (type_dmp == 'antecedent_pro') {
                dmp = 'Antécédents professionnels'
            } else if (type_dmp == 'antecedent_hereditaux') {
                dmp = 'Antécédents héréditaires et familiaux'
            } else if (type_dmp == 'vaccination') {
                dmp = 'Vaccinations'
            }
            this.$emit('changeView', { type_dmp: dmp, is_edit: true })
        }
    }
}


